



const app_promo = {
  "app_promo.block_title": "<span>Dapatkan keuntungan</span> <span><em>spesial ACUVUE® </em></span> <span> lewat layar Anda</span>",

  "app_promo.li_01": "Dapatkan penawaran eksklusif",
  "app_promo.li_02": "Dapatkan poin untuk setiap transaksi",
  "app_promo.li_03": "Tukarkan poin dengan lifestyle reward",

  "app_promo.cta_title": "Gratis 3 pasang ACUVUE® & Diskon Rp50.000!",
  "app_promo.cta_btn": "<a>Pelajari Lebih Lanjut</a>",
  "app_promo.cta_link": "https://www.acuvue.co.id/myacuvue",
  // TODO: FOR TH
  // "app_promo.cta_link": "https://www.acuvue.co.th/acuvuemember",
}

const shopnow = {
  "showNow.title": "Belanja Sekarang",
  "showNow.description": "Dapatkan penawaran online eksklusif dari ACUVUE® sekarang",

  "showNow.physical.details": "Temukan toko resmi ACUVUE® terdekat:",
  "buttonText.findStores": "Cari Toko",
}

const download_now = {
  "download_now.title": "Gratis 3 pasang ACUVUE® & diskon Rp50.000",
  "download_now.p": "Daftar MyACUVUE™ sekarang!",
  "download_now.button": "Pelajari Lebih Lanjut",
}

export default {
...shopnow,
...download_now,
...app_promo,
};

